import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function MinimumSquareFeet(
  this: ListingsService,
  listing: Listing,
  currentValue: boolean,
): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.minSqft()) {
    return currentValue;
  }

  // If the listing does not have a value, exclude it from results.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This condition is necessary until we update the logic to fit the new types package.
  if (!listing.squareFeet?.total) {
    return false;
  }

  // Determine if the listing matches the filter.
  const _value = parseInt(this.filteringService.minSqft(), 10);
  if (_value > listing.squareFeet.total) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
